<template>
  <div class="family-container">
    <div class="family-container_ cen">
      <div class="inside-main">
        <div class="family-main">
          <div class="volunteer-detail-item">我的家庭</div>
          <div class="family-main_">
            <div class="family-binding-tip">
              如果您的家人也是我们会员，可通过账户关联绑定您的家庭成员，<br>您可随时查看您家人的信息。
            </div>
            <div class="family-binding-btn" @click="bindingMember">绑定我的家庭成员</div>
            <div class="family-binding-list">
              <div class="family-binding-li" v-for="(item, index) in list" :key="item.member_id">
                <div class="binding-li-img" @click="showInfo(item.member_id,index)"><div></div></div>
                <div class="binding-li-info">
                  <div class="binding-li-title" @click="showInfo(item.member_id,index)">{{item.userinfo.cnname == '' ? item.userinfo.username : item.userinfo.cnname}}</div>
                  <div class="binding-li-btn" :class="[item.status == 'true' ? '' : 'no']" @click="changeBindStatus(index)">
                    <span>{{item.status == 'true' ? '已关注' : '关注'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">我的首页</div>
            <div class="enname">Member Center</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li">
              <router-link to="/member/index" class="left-nav-link">
                <div class="chname">基本信息</div>
                <div class="enname">Basic Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/security" class="left-nav-link">
                <div class="chname">个人安全信息</div>
                <div class="enname">Personal Safety Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/reserve" class="left-nav-link">
                <div class="chname">预约信息</div>
                <div class="enname">Reservation information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/member/family" class="left-nav-link">
                <div class="chname">我的家庭</div>
                <div class="enname">My Family</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popsbox">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hidePops"></div>
        <div class="dialog-form">
          <div class="dialog-inputbox">
            <div class="dialog-item">与家庭成员的关系：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <select v-model="formdata.relationship">
                  <option value="请选择">请选择</option>
                  <option v-for="(item, index) in relationList" :key="index" :value="item.dataname">{{item.dataname}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">绑定账号：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="formdata.bindingAccount" class="input" placeholder="请输入他的账号">
              </div>
              <div class="dialog-input-tip" v-if="errorCode == '2'">！未检测到当前用户</div>
              <div class="dialog-input-tip colr" v-if="errorCode == '4'">！已绑定用户信息</div>
            </div>
          </div>
          <div class="dialog-btn" @click="submitForm">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderData, getFamilyData, addFamilyData, delFamilyData, getRelationData } from '../../api/getData.js'
export default {
  name: 'family',
  data () {
    return {
      headerInfo: {},
      list: [],
      relationList: [],
      errorCode: 0,
      formdata: {
        relationship: '请选择',
        bindingAccount: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  created () {
    this.getHeaderInfo()
    this.getRelationInfo()
    this.getFamilyInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'member', activeSendMenu: 'family' }).then(() => {}).catch(() => {})
    },
    async getRelationInfo () {
      let result = await getRelationData()
      this.relationList = result.relation
    },
    async getFamilyInfo () {
      let postData = {}
      postData.id = this.getUserId
      let result = await getFamilyData(postData)
      this.list = result.list
    },
    async submitForm () {
      if (this.formdata.relationship === '请选择') {
        this.message('请选择与家庭成员的关系')
        return false
      }
      if (this.formdata.bindingAccount === '') {
        this.message('请输入绑定账号')
        return false
      }
      let postData = {}
      postData.id = this.getUserId
      postData.username = this.formdata.bindingAccount
      postData.relation = this.formdata.relationship
      let result = await addFamilyData(postData)
      this.errorCode = result.code
      if (result.code === '0') {
        this.message('绑定失败')
      } else if (result.code === '2') {
        this.message('用户不存在！')
      } else if (result.code === '3') {
        this.message('不能绑定自己！')
      } else if (result.code === '4') {
        this.message('该用户已绑定！')
      } else if (result.code === '1') {
        this.message('绑定成功')
        this.hidePops()
        this.getFamilyInfo()
        this.formdata = { relationship: '请选择', bindingAccount: '' }
      }
    },
    async changeBindStatus (index) {
      if (this.list[index].status === 'true') {
        let postData = {}
        postData.id = this.getUserId
        postData.member_id = this.list[index].member_id
        let result = await delFamilyData(postData)
        if (result.code === '0') {
          this.message('取消失败')
        } else if (result.code === '1') {
          this.message('取消成功')
          this.list[index].status = 'false'
        }
      } else {
        let postData = {}
        postData.id = this.getUserId
        postData.username = this.list[index].userinfo.username
        postData.relation = this.list[index].relation
        let result = await addFamilyData(postData)
        if (result.code === '0') {
          this.message('关注失败')
        } else if (result.code === '1') {
          this.message('关注成功')
          this.list[index].status = 'true'
        }
      }
    },
    showInfo (id, index) {
      if (this.list[index].status === 'false') {
        this.message('您未绑定该用户！')
        return false
      }
      this.$router.push({ path: '/attention/index', query: { id: id } })
    },
    bindingMember () {
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.popsbox').stop().fadeIn(500)
    },
    hidePops () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.popsbox').stop().fadeOut(500)
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .family-container_{
    padding: 40px 0 60px;
  }
  .family-main{
    width: 77.22%;
    padding: 0 64px 80px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #eb6420;
      margin-top: 60px;
      padding-left: 25px;
      font-size: 30px;
      line-height: 30px;
      color: #eb6420;
    }
    .family-main_{
      padding: 0 7px;
      .family-binding-tip{
        margin-top: 28px;
        font-size: 24px;
        line-height: 40px;
        color: #333333;
      }
      .family-binding-btn{
        width: 365px;
        height: 75px;
        margin: 30px 0 0;
        border-radius: 5px;
        background-color: #eb6420;
        font-size: 24px;
        line-height: 75px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
      .family-binding-list{
        margin: 70px 0 0;
        padding: 50px 0 0;
        border-top: 1px solid #cccccc;
        overflow: hidden;
        .family-binding-li{
          float: left;
          width: 33.33%;
          margin-bottom: 30px;
          overflow: hidden;
          .binding-li-img{
            float: left;
            width: 96px;
            height: 96px;
            border-radius: 50%;
            background-color: #f4f4f9;
            margin-right: 20px;
            div{
              width: 100%;
              height: 100%;
              border-radius: 50%;
              background-image: url("../../assets/images/icons.png");
              background-repeat: no-repeat;
              background-position: -332px -424px;
            }
          }
          .binding-li-info{
            padding: 16px 0 0;
            overflow: hidden;
            .binding-li-title{
              font-size: 20px;
              line-height: 35px;
              color: #333333;
            }
            .binding-li-btn{
              width: 80px;
              height: 30px;
              border-radius: 5px;
              border: 1px solid #e5e5e5;
              margin: 8px 0 0;
              font-size: 14px;
              line-height: 28px;
              text-align: center;
              color: #666666;
              cursor: pointer;
              transition: all 0.5s ease 0s;
              &.no{
                background-color: #eb6420;
                color: #ffffff;
              }
              &:hover{
                background-color: #eb6420;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
  .inside-left-nav{
    padding-bottom: 150px;
  }
  .popsbox{
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.7);
    .popsbox_{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 830px;
      padding: 67px 0 58px;
      background-color: #ffffff;
      border-radius: 5px;
      .popsbox_close{
        position: absolute;
        top: 20px;
        right: 20px;
        width: 28px;
        height: 28px;
        background-image: url("../../assets/images/icons.png");
        background-repeat: no-repeat;
        background-position: -60px -450px;
        cursor: pointer;
        transition: transform 0.5s ease 0s;
        &:hover{
          transform: rotate(180deg);
          background-image: url("../../assets/images/pic06.png");
          background-repeat: no-repeat;
          background-position: 0 0;
        }
      }
      .dialog-inputbox{
        height: 40px;
        margin-bottom: 20px;
        .dialog-item{
          float: left;
          width: 33.13%;
          font-size: 24px;
          line-height: 40px;
          text-align: right;
          color: #333333;
        }
        .dialog-input{
          position: relative;
          float: left;
          width: 66.87%;
          height: 40px;
          .dialog-input_{
            float: left;
            position: relative;
            width: 60%;
            margin-right: 10px;
            .input{
              width: 100%;
              padding: 0 12px;
              border-radius: 5px;
              background-color: #eeeeee;
              font-size: 18px;
              line-height: 40px;
              color: #333333;
            }
            select{
              width: 100%;
              height: 40px;
              border: none;
              border-radius: 5px;
              background: #eeeeee url('../../assets/images/select.png') no-repeat right center;
              margin-right: 40px;
              padding: 0 12px;
              font-size: 18px;
              line-height: 40px;
              color: #333333;
              appearance: none;
              outline: none;
            }
          }
          .dialog-input-tip{
            float: left;
            font-size: 18px;
            line-height: 40px;
            color: #ff2d2d;
            &.colr{
              color: #17bc42;
            }
          }
        }
      }
      .dialog-btn{
        width: 140px;
        height: 38px;
        border-radius: 5px;
        background-color: #eb6420;
        margin: 50px auto 0;
        font-size: 18px;
        line-height: 38px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  @media screen and (max-width: 1580px){
    .family-container_{
      padding: 40px 30px 60px;
    }
  }
  @media screen and (max-width: 1200px){
    .family-container_{
      padding: 25px 10px 5px;
    }
    .family-main{
      width: 100%;
      margin-bottom: 20px;
      padding: 30px 15px 7px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #eb6420;
        margin-top: 0;
        padding-left: 9px;
        font-size: 15px;
        line-height: 15px;
      }
      .family-main_{
        padding: 0;
        .family-binding-tip{
          margin-top: 13px;
          font-size: 12px;
          line-height: 22px;
        }
        .family-binding-btn{
          width: 182px;
          height: 38px;
          margin: 17px 0 0;
          border-radius: 3px;
          font-size: 12px;
          line-height: 38px;
        }
        .family-binding-list{
          margin: 30px 0 0;
          padding: 30px 0 0;
          .family-binding-li{
            float: none;
            width: 100%;
            margin-bottom: 22px;
            .binding-li-img{
              float: left;
              width: 48px;
              height: 48px;
              margin-right: 11px;
              div{
                background-size: 230px auto;
                background-position: -166px -212px;
              }
            }
            .binding-li-info{
              padding: 15px 0;
              .binding-li-title{
                float: left;
                font-size: 12px;
                line-height: 18px;
              }
              .binding-li-btn{
                float: right;
                width: 50px;
                height: 18px;
                border-radius: 3px;
                margin: 0;
                font-size: 9px;
                line-height: 16px;
              }
            }
          }
        }
      }
    }
    .inside-left-nav{
      display: none;
    }
    .popsbox{
      .popsbox_{
        top: 50%;
        left: 17px;
        right: 17px;
        transform: translateY(-50%);
        width: auto;
        padding: 30px 0 28px;
        border-radius: 3px;
        .popsbox_close{
          top: 10px;
          right: 10px;
          width: 14px;
          height: 14px;
          background-size: 230px auto;
          background-position: -30px -225px;
          &:hover{
            background-image: url("../../assets/images/pic06.png");
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 13px auto;
          }
        }
        .dialog-inputbox{
          height: auto;
          margin-bottom: 10px;
          padding: 0 22px;
          .dialog-item{
            float: none;
            width: 100%;
            font-size: 14px;
            line-height: 26px;
            text-align: left;
          }
          .dialog-input{
            float: none;
            width: 100%;
            height: auto;
            .dialog-input_{
              position: relative;
              float: none;
              width: 100%;
              margin-right: 0;
              .input{
                width: 100%;
                padding: 0 12px;
                border-radius: 3px;
                font-size: 12px;
                line-height: 30px;
              }
              select{
                height: 30px;
                border-radius: 3px;
                background-size: 30px;
                margin-right: 0;
                padding: 0 12px;
                font-size: 12px;
                line-height: 30px;
              }
            }
            .dialog-input-tip{
              float: none;
              font-size: 10px;
              line-height: 30px;
            }
          }
        }
        .dialog-btn{
          width: 100px;
          height: 30px;
          border-radius: 3px;
          margin: 15px auto 0;
          font-size: 14px;
          line-height: 30px;
        }
      }
    }
  }
</style>
